import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { DadosAdicionaisModelo } from '../../models/dados-adicionais-modelo.model';
import { DadosAdicionaisModeloService } from '../../services/dados-adicionais-modelo.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-dados-adicionais-modelo-list',
  templateUrl: './dados-adicionais-modelo-list.component.html',
  styleUrls: ['./dados-adicionais-modelo-list.component.scss']
})
export class DadosAdicionaisModeloListComponent extends BaseListComponent<DadosAdicionaisModelo> implements OnInit, OnDestroy {

  dadosList: DadosAdicionaisModelo[];

  constructor(
    private myService: DadosAdicionaisModeloService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.dadosList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/dados-adicionais-modelo/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/dados-adicionais-modelo/', id];
  }
}
